// src/utils下创建i18n/index.js
import Vue from 'vue'
import VueI18n from 'vue-i18n'

// 引入各个语言配置文件
// import zh from './langs/zh'
import TW from './langs/TW'
import en from './langs/enus'
import enus from './langs/enus'
import enuk from './langs/enuk'
import Thai from './langs/Thai'
import Jap from './langs/Jap'
import Korean from './langs/Kor'
// import Vietnamese from './langs/Vie'
// import Indonesia from './langs/Rep'
import French from './langs/Fra'
import German from './langs/Ger'
import Hindi from './langs/Hindi'
import Urdu from './langs/Urdu'

Vue.use(VueI18n)
let lang = 'enus';
try {
    const storedLang = JSON.parse(localStorage.getItem('lang'));
    lang = storedLang ? storedLang : 'enus';
} catch (error) {
    lang = 'enus';
}

// 创建vue-i18n实例i18n
const i18n = new VueI18n({
    // 设置默认语言
    locale: lang, // 语言标识
    // 添加多语言（每一个语言标示对应一个语言文件）
    messages: {
        en,
        // zh,
        TW,
        enus,
        enuk,
        Thai,
        Jap,
        Korean,
        // Vietnamese,
        // Indonesia,
        French,
        German,
        Hindi,
        Urdu
    }
})
// 暴露i18n
export default i18n
